import React from 'react'
import PropTypes from 'prop-types'
import { Document, Page, PDFDownloadLink, StyleSheet, Text } from '@react-pdf/renderer'
import { GetApp } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { v4 as uuidv4 } from 'uuid'
import { formatInBrazilianDate, formatInBrazilianDatetime, maskString } from "../../../utils/functions"
import Header from "../Header"
import Section, { SectionContent, SectionHeader } from "../Section"
import { DataField } from "../Label"
import { BGC_FIELDS } from "../../../utils/constants/bgcFields"
import BgcVariables from "./BgcVariables"
import ErrorDataText from "./ErrorDataText"


const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    padding: 32,
    fontSize: 12,
    color: 'black',
  },
})

const BackgroundCheckDocument = ({ backgroundCheck }) => {
  const excludedFields = [
    BGC_FIELDS.risk_score,
    BGC_FIELDS.credit_score_data,
    BGC_FIELDS.financial_pendings_data,
  ]

  if (!backgroundCheck) {
    return <Text>Carregando...</Text>
  }

  const findScore = (type) => {
    const scoreData = backgroundCheck.score_board.score_data
    return scoreData[type]
  }

  return (<Document>
    <Page size="A4" style={styles.page}>
      <Header text={'Background Check - Know Your Partner\nPowered by Dimensa'} />

      <Section>
        <SectionHeader text="Dados Pessoais" />
        <SectionContent>
          <DataField label="Nome:" value={backgroundCheck.person.name} />
          <DataField label="CPF:" value={maskString(backgroundCheck.person.cpf, 'cpf')} />
          <DataField
            label="Data de Nascimento:"
            value={formatInBrazilianDate(backgroundCheck.person.birth_date)}
          />
          <DataField label="Filiação:" value={backgroundCheck.person.affiliation} />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader text="Background Check" />
        <SectionContent>
          <DataField
            label="Data de criação da Análise:"
            value={formatInBrazilianDatetime(backgroundCheck.created)}
          />
          <DataField label="Score Final:" value={`${backgroundCheck.score_board.final_score} ponto(s)`} />
          <DataField label="Risco:" value={backgroundCheck.score_board.risk} />
        </SectionContent>
      </Section>

      {
        Object.values(BGC_FIELDS).map((field) => {
          try {
            if (!excludedFields.includes(field)) {
              let score_data

              if (field === BGC_FIELDS.financial_situation) {
                score_data = findScore(BGC_FIELDS.financial_pendings_data)
              } else {
                score_data = findScore(field)
              }

              return (
                <BgcVariables
                  key={uuidv4()}
                  field={field}
                  bgc_info={backgroundCheck ? backgroundCheck[field] : null}
                  score_data={score_data}
                />
              )
            }
            return null
          } catch (err) {
            return (
              <Section>
                <ErrorDataText
                  exception={err}
                  contextName="BackgroundCheckPDFDownloadLink"
                  extraData={backgroundCheck}
                />
              </Section>
            )
          }
        })
      }
    </Page>
  </Document>)
}

const renderLabeledButton = (disabled) => (
  <Button
    size="small"
    variant="outlined"
    disabled={disabled}
    startIcon={<GetApp />}
    title="Baixar PDF do background check"
  >
    Baixar em PDF
  </Button>
)

const BackgroundCheckPDFDownloadLink = ({ backgroundCheck }) => {
  if (backgroundCheck.status !== 'PROCESSED') {
    return renderLabeledButton(true)
  }

  return (
    <PDFDownloadLink
      document={<BackgroundCheckDocument backgroundCheck={backgroundCheck} />}
      fileName={`bgc_kyp_${backgroundCheck.uuid}.pdf`}
    >
      {renderLabeledButton(false)}
    </PDFDownloadLink>
  )
}

BackgroundCheckPDFDownloadLink.propTypes = {
  backgroundCheck: PropTypes.object.isRequired,
}

export default BackgroundCheckPDFDownloadLink
